var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"totals-row"},[_c('h6',{class:{'cart-total': _vm.$props.cartTotal}},[_vm._v(" "+_vm._s(_vm.$props.totalName)+" "),_c('span',{staticClass:"total-price-note"},[_vm._v(_vm._s(_vm.$props.note))])]),_c('div',{staticClass:"total-price-wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }